import { Component, OnInit } from '@angular/core';
import { ArticleService } from './hometwo-banner/articles.service';
import { forkJoin, finalize } from 'rxjs';

@Component({
  selector: 'app-home-demo-two',
  templateUrl: './home-demo-two.component.html',
  styleUrls: ['./home-demo-two.component.scss']
})
export class HomeDemoTwoComponent implements OnInit {
  // États de chargement
  isLoading = true;
  hasError = false;
  errorMessage = '';
  
  // Données pour le banner
  bannerData: any;
  spotlightArticle: any;

  constructor(private articleService: ArticleService) { }

  ngOnInit(): void {
    this.loadContent();
  }

  private loadContent(): void {
    this.isLoading = true;
    this.hasError = false;
    
    // Utilisation de forkJoin pour charger les deux sources de données en parallèle
    forkJoin({
      latestArticles: this.articleService.getLatestArticle(),
      spotlightArticle: this.articleService.getSpotlightArticle()
    }).pipe(
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe({
      next: (results: any) => {
        this.bannerData = results.latestArticles?.data;
        this.spotlightArticle = results.spotlightArticle.data.length > 0
          ? results.spotlightArticle.data[0]
          : {};
      },
      error: (error) => {
        this.hasError = true;
        this.errorMessage = 'Erreur lors du chargement des articles';
        console.error('Erreur de chargement:', error);
      }
    });
  }

  // Méthode pour retry en cas d'erreur
  retryLoad(): void {
    this.loadContent();
  }
}